(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/envelope/assets/javascripts/components/concave-shadow.js') >= 0) return;  svs.modules.push('/components/tur/envelope/assets/javascripts/components/concave-shadow.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const MAX_HEIGHT = 50;
const MAX_WIDTH = 366;
const MAX_OFFSET_X = 7;
const MAX_OFFSET_Y = 15;
const MAX_CONCAVE_DEPTH = 35;
const MAX_OFFSET_Y_SHADOW = 4;
const MAX_TOP_OFFSET = 30;
const createBeizerCurve = function (newCurveWidth, depth) {
  let offsetX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let offsetY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const newPoint1 = "".concat(0.25 * newCurveWidth, ",").concat(depth);
  const newPoint2 = "".concat(0.75 * newCurveWidth, ",").concat(depth);
  const newPoint3 = "".concat(newCurveWidth - offsetX, ",").concat(offsetY);
  return [newPoint1, newPoint2, newPoint3].join(' ');
};
const createPaths = newCurveWidth => {
  const scale = newCurveWidth / MAX_WIDTH;
  const height = Math.min(MAX_HEIGHT, MAX_HEIGHT * scale);
  const offsetX = Math.min(MAX_OFFSET_X, MAX_OFFSET_X * scale);
  const offsetY = Math.min(MAX_OFFSET_Y, MAX_OFFSET_Y * scale);
  const depth = Math.min(MAX_CONCAVE_DEPTH, MAX_CONCAVE_DEPTH * scale);
  return {
    concave: "M0,0 C".concat(createBeizerCurve(newCurveWidth, depth), " L").concat(newCurveWidth, ",").concat(height, " L0,").concat(height, " Z"),
    shadow: "M".concat(offsetX, ",").concat(offsetY, " C").concat(createBeizerCurve(newCurveWidth, depth, offsetX, offsetY), " L").concat(newCurveWidth - offsetX, ",").concat(height, " L").concat(offsetX, ",").concat(height, " Z")
  };
};
const getTopOffset = parentWidth => {
  const percentOfMaxWidth = parentWidth / MAX_WIDTH;
  return -Math.min(MAX_TOP_OFFSET, percentOfMaxWidth * MAX_TOP_OFFSET);
};
const getDropShadowFilter = parentWidth => {
  const scale = parentWidth / MAX_WIDTH;
  const offsetY = Math.min(MAX_OFFSET_Y_SHADOW, scale * MAX_OFFSET_Y_SHADOW);
  const blur = Math.min(MAX_OFFSET_Y_SHADOW, scale * MAX_OFFSET_Y_SHADOW);
  return "drop-shadow(0px ".concat(-offsetY, "px ").concat(blur, "px rgba(0, 0, 0))");
};
const ConcaveShadow = _ref => {
  let parentRef = _ref.parentRef,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? 'white' : _ref$fillColor;
  const dropShadowRef = useRef(getDropShadowFilter(parentRef.current.offsetWidth));
  const topOffsetRef = useRef(getTopOffset(parentRef.current.offsetWidth));
  const _useState = useState(createPaths(parentRef.current.offsetWidth)),
    _useState2 = _slicedToArray(_useState, 2),
    svgPaths = _useState2[0],
    setSvgPaths = _useState2[1];
  useEffect(() => {
    const lazyOnResizeTicket = _.debounce(() => {
      const bodyWidth = parentRef.current.offsetWidth;
      dropShadowRef.current = getDropShadowFilter(bodyWidth);
      topOffsetRef.current = getTopOffset(bodyWidth);
      setSvgPaths(createPaths(bodyWidth));
    }, 10);
    window.addEventListener('resize', lazyOnResizeTicket);
    return () => {
      window.removeEventListener('resize', lazyOnResizeTicket);
    };
  }, []);
  return React.createElement("div", {
    className: "relative",
    style: {
      top: topOffsetRef.current,
      overflowX: 'visible'
    }
  }, React.createElement("div", {
    className: "absolute w100",
    style: {
      filter: dropShadowRef.current
    }
  }, React.createElement("svg", {
    className: "absolute w100 u-left-50 u-translate-middle-x"
  }, React.createElement("path", {
    d: svgPaths.shadow
  }))), React.createElement("svg", {
    className: "absolute w100 u-left-50 u-translate-middle-x"
  }, React.createElement("path", {
    d: svgPaths.concave,
    fill: fillColor
  })));
};
setGlobal('svs.tur.envelope.components.ConcaveShadow', ConcaveShadow);

 })(window);